export default __webpack_public_path__ + "static/media/puff-geosecma-linkedin_5b7379b94614dde24934c92e27c1ba9c.c602acf1.png";